export const sexos = [{ value: "M", label: "Masculino" }, { value: "F", label: "Feminino" }];
export const tiposRelacionamento = ["Cônjuge", "Sócio", "Procurador", "Familiar", 'Terceiro Autorizado'];
export const grausParentesco = ['Irmão', 'Pai', 'Mãe', 'Filho', 'Outros'];
